export const MAX_PIXEL_WIDTH = "10000";
export const MAX_PIXEL_HEIGHT = "10000";
export const ICO_INQUIRY_EMAIL = "sellyourcar@throttle.ca";
export const NEW_BUYER_PROMO_CODE = "NEWBUYER150";

// consistent with dealcentral, we just need to get this up asap, but i would like
// a properly thought out way to accomplish this without doing exactly this
export const MIN_AUTO_OFFER = 500;
export const MIN_VALUE_ESTIMATE = 100;
export const MIN_MEDIAN_VALUE_ESTIMATE = 300;
export const MIN_MAX_VALUE_ESTIMATE = 500;
